export const DAO_CODE = 'PRODUCTIONS' + '_DAO';
